import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
// import { useSelector } from 'react-redux';
const SOCKET_URL = 'wss://smartliddev.birlanu.com/backend/'; // use wss:// for secure
const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const [kpiData, setKpiData] = useState(null); // store your update here
  const [deviceData, setDeviceData] = useState(null); // store your update here
  const [alertData, setAlertData] = useState(null); // store your update here
  const [deviceAnalysisData, setDeviceAnalysisData] = useState(null);
  // const deviceId = useSelector((state) => state.auth.deviceId);
  useEffect(() => {
    const ws = new WebSocket(SOCKET_URL);
    socketRef.current = ws;

    ws.onopen = () => console.log('✅ WS connected');

    ws.onmessage = (msg) => {
      try {
        const data = JSON.parse(msg.data);

        // check if it’s your event
        if (data?.event === 'user_kpi_update') {
          setKpiData(data); // save to state
        }

        if (data?.event === 'device_reading_update') {
          setDeviceData(data); // save to state
        }

        if (data?.event === 'device-alerts') {
          setAlertData(data); // save to state
        }
        //real-time update for device analysis page
        if (data?.event === 'device_current_reading_user') {
          setDeviceAnalysisData(data); // save to state
        }
      } catch (e) {
        console.error('WS parse error:', e);
      }
    };

    ws.onclose = () => console.log('❌ WS disconnected');

    return () => ws.close();
  }, []);

  return (
    <SocketContext.Provider
      value={{
        socket: socketRef.current,
        kpiData,
        deviceData,
        alertData,
        deviceAnalysisData,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};
